import React from 'react';
import {
  Box, Button, Chip, Dialog, DialogActions, DialogContent, DialogTitle,
  Stack, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead,
  TableRow, Typography,
} from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';

import { euros, libelleOrigine, libelleTva, nombre } from './constantes';
import { themeExpert } from '../../theme/expert';

/** Le chiffrage entier, d'un seul tenant — pour relire avant d'envoyer. */
export default function Recapitulatif({ ouvert, onFermer, totaux, postes,
                                        details }) {
  return (
    <ThemeProvider theme={themeExpert}>
      <Dialog open={ouvert} onClose={onFermer} fullWidth maxWidth="lg"
              scroll="paper">
        <DialogTitle>Récapitulatif du chiffrage</DialogTitle>
        <DialogContent dividers>
          <Stack spacing={4}>
            <TableContainer>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Poste</TableCell>
                    <TableCell align="right">Réclamé</TableCell>
                    <TableCell align="right">Calculé</TableCell>
                    <TableCell align="right">Assuré HTVA</TableCell>
                    <TableCell align="center">TVA</TableCell>
                    <TableCell align="right">Assuré TTC</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {postes.map((poste) => (
                    <TableRow key={poste.id}>
                      <TableCell>
                        {poste.index} {poste.title}
                      </TableCell>
                      <TableCell align="right">
                        {euros(poste.reclamer)}
                      </TableCell>
                      <TableCell align="right">
                        {euros(poste.calculer)}
                      </TableCell>
                      <TableCell align="right">
                        {euros(poste.accorder)}
                      </TableCell>
                      <TableCell align="center">
                        {libelleTva(poste.tva)}
                      </TableCell>
                      <TableCell align="right">
                        {euros(nombre(poste.accorder)
                               * (1 + nombre(poste.tva) / 100))}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
                <TableFooter>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 700,
                                     color: 'text.primary' }}>Total</TableCell>
                    <TableCell align="right" sx={{ fontWeight: 700,
                                                   color: 'text.primary' }}>
                      {euros(totaux.totalReclamerHtva)}
                    </TableCell>
                    <TableCell align="right" sx={{ fontWeight: 700,
                                                   color: 'text.primary' }}>
                      {euros(totaux.totalCalculerHtva)}
                    </TableCell>
                    <TableCell align="right" sx={{ fontWeight: 700,
                                                   color: 'text.primary' }}>
                      {euros(totaux.totalAccorderHtva)}
                    </TableCell>
                    <TableCell />
                    <TableCell align="right" sx={{ fontWeight: 700,
                                                   color: 'text.primary' }}>
                      {euros(totaux.totalAccorderTtc)}
                    </TableCell>
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>

            {postes.map((poste) => (
              <Box key={`detail-${poste.id}`}>
                <Stack direction="row" spacing={1} alignItems="baseline"
                       sx={{ mb: 1 }}>
                  <Typography variant="h3">
                    {poste.index} {poste.title}
                  </Typography>
                  <Chip size="small" variant="outlined"
                        label={libelleOrigine(poste.origin)} />
                </Stack>

                {poste.comment ? (
                  <Box className="texte-riche" sx={{ mb: 2, '& p:last-child': { mb: 0 } }}
                       dangerouslySetInnerHTML={{ __html: poste.comment }} />
                ) : (
                  <Typography variant="body2" sx={{ color: 'text.disabled',
                                                    mb: 2 }}>
                    Pas d'analyse.
                  </Typography>
                )}

                {/* Seuls les postes dont les lignes ont été ouvertes sont
                    détaillés : on n'affiche que ce qui a été chargé. */}
                {details[poste.id]?.length > 0 && (
                  <TableContainer>
                    <Table size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell>Libellé</TableCell>
                          <TableCell align="right">P.U.</TableCell>
                          <TableCell align="center">Unité</TableCell>
                          <TableCell align="right">Quantité</TableCell>
                          <TableCell align="right">Total</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {details[poste.id].map((ligne) => (
                          <TableRow key={ligne.id}>
                            <TableCell>{ligne.title}</TableCell>
                            <TableCell align="right">
                              {euros(ligne.unitValue)}
                            </TableCell>
                            <TableCell align="center">{ligne.unit}</TableCell>
                            <TableCell align="right">
                              {ligne.quantity}
                            </TableCell>
                            <TableCell align="right">
                              {euros(ligne.total)}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                      <TableFooter>
                        <TableRow>
                          <TableCell colSpan={4} sx={{ fontWeight: 700,
                                                       color: 'text.primary' }}>
                            Total du chiffrage
                          </TableCell>
                          <TableCell align="right"
                                     sx={{ fontWeight: 700,
                                           color: 'text.primary' }}>
                            {euros(poste.total)}
                          </TableCell>
                        </TableRow>
                      </TableFooter>
                    </Table>
                  </TableContainer>
                )}
              </Box>
            ))}
          </Stack>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={onFermer}>Fermer</Button>
        </DialogActions>
      </Dialog>
    </ThemeProvider>
  );
}
